import { Component, HostListener, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { RfAuthenticationService } from 'src/app/authentication/rf-authentication.service'
import { ConnectUserComponent } from 'src/app/feature/my-profile/components/profile/components/connect-user/connect-user.component'
import { ManageCredentialsComponent } from 'src/app/feature/my-profile/components/profile/components/manage-credentials/manage-credentials.component'
import { BaseComponent } from 'src/app/shared/components/base/base.component'
import { ProfileChooseService } from 'src/app/shared/components/dialog/components/profile-choose/service/profile-choose.service'
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service'
import { IconModel } from 'src/app/shared/components/icon/model/icon.model'
import { ApiSearchUtilService } from 'src/app/shared/service/api-search-util/api-search-util.service'
import { CsManagementService } from 'src/app/shared/service/store-management/cs-management/cs-management.service'
import { HierarchyManagementService } from 'src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service'
import { ProfileManagementService } from 'src/app/shared/service/store-management/profile-management/profile-management.service'
import { StoreManagementService } from 'src/app/shared/service/store-management/store-management.service'
import { UserService } from 'src/app/shared/service/user/user.service'
import { SubSink } from 'subsink'

import { USER_PROFILE_ENUM } from './model/user-profile.enum'
import { defaultUserProfileMenu } from './userProfileMenu'
import { StorageService } from 'src/app/shared/service/storage/storage.service'
import { WelcomeAlertComponent } from 'src/app/feature/home/welcome-alert/welcome-alert/welcome-alert.component'
import { CustomerChooseService } from 'src/app/shared/components/dialog/components/customer-choose/service/customer-choose.service'
import { avoidHomeInitWelcome } from 'src/environments/environment'
import { CommonModule } from '@angular/common'
import { MaterialModule } from 'src/app/shared/module/material.module'
import { I18nPipe } from 'src/app/shared/i18n/pipe/i18n.pipe'
import { IconComponent } from 'src/app/shared/components/icon/icon.component'
import { MyAldEventDirective } from 'src/app/shared/directives/myald-event.directive'
import { InformativeNotesService } from 'src/app/feature/home/informative-notes/service/informative-notes.service'
@Component({
    selector: 'ald-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    imports: [
        CommonModule,
        MaterialModule,
        I18nPipe,
        IconComponent,
        MyAldEventDirective
    ]
})
export class UserProfileComponent extends BaseComponent implements OnInit {
	userName: any;
	role: string
	menuItems = []
	isMobile = false
	iconMenuUser

	private subs: SubSink = new SubSink()

	constructor(
		private route: Router,
		private authService: RfAuthenticationService,
		private storeManagement: StoreManagementService,
		private dialog: DialogService,
		private profileManagementService: ProfileManagementService,
		private profileChooseService: ProfileChooseService,
		private userService: UserService,
		private apiSearchUtilService: ApiSearchUtilService,
		private csManagementService: CsManagementService,
		private hierarchyManagementService: HierarchyManagementService,
		private storageSrv: StorageService,
		private customerChooseService: CustomerChooseService,
		private informativeNotesService: InformativeNotesService
	) {
		super()
	}

	ngOnInit(): void {
		this.loadDefaultMenu()
		//this.getUsernameFromSession()
		this.userName = sessionStorage.getItem('userName');
		// if(!this.userName) {
		// }
		this.getUsernameFromSession()
		this.isMobileWidth(window.innerWidth)

		this.subs.add(
			this.profileChooseService.getProfile().subscribe((res) => {
				const profiles: any = this.profileManagementService.getProfilesByStore()
				const profile = this.profileManagementService.getProfileByStore()
				if (!!profile) {
					const { role, roles } = profile
					const fullMenu = defaultUserProfileMenu
					this.menuItems = fullMenu.filter((el) => el.roles.length === 0 || el.roles.includes(role))
					this.chooseProfileUserMenu(profiles, roles)
					this.manageSalesUserMenu(profile)
					this.manageVehicleMenu(profile)
					this.checkIfUserIsCustomerService()
					this.manageCQMenu(profile)
					if (avoidHomeInitWelcome.showed == false) {
						// Note informative CMS (CO-9067): mostrate in sequenza, una volta per sessione.
						this.informativeNotesService.showInformativeNotesOncePerSession(this.isMobile)
						avoidHomeInitWelcome.showed = true
					}
					//	this.openWelcomeAlert()
				}
			})
		)
	}

	manageVehicleMenu(profiles) {
		if (!!profiles && !profiles.isMulti) {
			const arr = this.menuItems.filter((menuEl) => {
				return menuEl.description !== 'manage_plate'
			})
			this.menuItems = []
			this.menuItems = arr
		}
	}

	chooseProfileUserMenu(profiles, roles) {
		if (!!profiles && profiles?.length === 1 && roles.length === 1) {
			const arr = this.menuItems.filter((menuEl) => {
				return menuEl.description !== 'choose_profile'
			})
			this.menuItems = []
			this.menuItems = arr
		}
	}

	manageSalesUserMenu(profiles) {
		if (!!profiles && !profiles.isSales && !(profiles.role == '11')) {
			const arr = this.menuItems.filter((menuEl) => {
				return menuEl.description !== 'manage_sales'
			})
			this.menuItems = []
			this.menuItems = arr
		}
	}

	manageCQMenu(profiles) {
		if (!!profiles && profiles.isCorporateQuoterEnabled && (profiles.role == '400035' || profiles.role == '1' || profiles.role == '400036' || profiles.role == '400037' || profiles.role == '400038')) {
			const arr = this.menuItems.filter((menuEl) => {
				return menuEl.description !== 'choose_profile' && menuEl.description !== 'user_connect' && menuEl.description !== 'my_vehicle'
			})
			this.menuItems = []
			this.menuItems = arr
		}
	}

	checkIfUserIsCustomerService() {
		const rawToken = sessionStorage.getItem('id_token') ?? localStorage.getItem('id_token');
		if (!rawToken) return; // Esci se non c'è il token
		const token = this.getDecodedAccessToken(rawToken);
		this.subs.add(
			this.profileManagementService.getCustomerServiceRole().subscribe((customerServiceRoles) => {
				// Usiamo l'optional chaining (?.) per evitare il crash se token è null
				const customerKey = token?.roles ? token.roles[0] : null;
				if (!customerKey) return; // Se non c'è una chiave, non possiamo confrontare
				const isPresent = customerServiceRoles.some((csKey) => csKey === customerKey);
				if (!isPresent) {
					this.menuItems = this.menuItems.filter((menuEl) => {
						return menuEl.description !== 'choose_user';
					});
				}
			})
		);
	}

	loadDefaultMenu(): void {
		const fullMenu = defaultUserProfileMenu
		this.menuItems = fullMenu.filter((el) => el.id == 7)
	}

	filterMenuStartingFromMenu(): void {
		const profile = this.profileManagementService.getProfileByStore()
		if (profile) {
			this.menuItems =
				profile.role === '1'
					? this.menuItems
					: this.apiSearchUtilService.removeElementFromArray(this.menuItems, 'my_vehicle')
		}
	}

	getUsernameFromSession(): void {
		let profileInSession = this.profileManagementService.getProfileByStore()
		this.subs.add(
			this.storeManagement.userInfo.subscribe((userInfo) => {
				profileInSession = userInfo ? userInfo : profileInSession
				this.setUserName(profileInSession)
				this.setRole(profileInSession)
			})
		)
		this.setUserName(profileInSession)
		this.setRole(profileInSession)
	}

	setUserName(profileInSession): void {
		this.userName = !!profileInSession ? this.setFullName(profileInSession) : 'User'
	}

	setRole(profileInSession): void {
		// this.role = !!profileInSession ? profileInSession.roleName : ''
		this.role = profileInSession ? profileInSession.lc === 400106 && profileInSession.role == "1" ? 'Referente' : profileInSession.roleName || '' : '';
	}

	setFullName(profileInSession): string {
		const firstName = !!profileInSession.firstName ? profileInSession.firstName : ''
		const lastName = !!profileInSession.lastName ? profileInSession.lastName : ''
		return firstName + ' ' + lastName
	}

	doAction(item): void {
		switch (item.action) {
			case USER_PROFILE_ENUM.LOGOUT:
				this.authService.logout()
				break
			case USER_PROFILE_ENUM.MANAGE_CREDENTIAL: {
				this.setItemsToManageCredentialDialog()
				break
			}
			case USER_PROFILE_ENUM.USER_CONNECT: {
				this.onConnectUserTrigger()
				break
			}
			case USER_PROFILE_ENUM.TOGGLE_OFF: {
				this.setToggleOf()
				break
			}
			case USER_PROFILE_ENUM.MANAGE_ACCOUT: {
				this.manageAccount()
				break
			}
			case USER_PROFILE_ENUM.MANAGE_SALES: {
				this.manageSales()
				break
			}
			case USER_PROFILE_ENUM.MANAGE_PLATE: {
				this.managePlate()
				break
			}
			default:
				this.route.navigate([item.action])
				break
		}
	}

	manageSales() {
		const profile = this.profileManagementService.getProfileByStore()
		this.profileManagementService.manageSales(profile, this.isMobile)
	}
	managePlate() {
		const profile = this.profileManagementService.getProfileByStore()
		this.route.navigate(['home'])
		this.profileManagementService.checkIfThereAreMoreVehicleAndSelectedOneOfThem(profile)
	}

	manageAccount() {
		this.csManagementService.setCustomerService(this.isMobile)
	}

	onConnectUserTrigger() {
		this.subs.add(
			this.dialog.onOpenDialogResponsive(this.isMobile, ConnectUserComponent, '').subscribe((_) => console.log(_))
		)
	}

	openWelcomeAlert() {
		const welcomeAlert = this.storageSrv.getSessionStorage('welcomeAlert')
		if (!!!welcomeAlert) {
			this.subs.add(
				this.dialog
					.onOpenDialogResponsive(this.isMobile, WelcomeAlertComponent, '')
					.subscribe((_) => this.storageSrv.setSessionStorage('welcomeAlert', _))
			)
		}
		avoidHomeInitWelcome.showed = true;
	}

	checkIfCS() {
		const cs_externalId = sessionStorage.getItem('cs_externalId')
		return !!cs_externalId
			? this.customerChooseService.getContactProfileByExternalId(cs_externalId)
			: this.userService.getContactProfile()
	}

	setToggleOf(): void {
		this.subs.add(
			this.checkIfCS()
				.pipe(filter((res: any) => !!res.profiles[0]))
				.subscribe((res: any) => {
					const profiles = res.profiles
					if (this.profileManagementService.conditionForChooseProfile(profiles)) {
						this.subs.add(
							this.profileManagementService
								.openDialogForChooseProfile(this.isMobile, profiles, true)
								.subscribe((profileSelected) => {
									console.log('profileSelected ', profileSelected)
									this.profileManagementService.removeProfileFromStore()
									this.profileManagementService.checkIfRegisteredAndStoreProfileSelected(profileSelected)
									this.profileManagementService.setChangeProfile(profileSelected)
									// Il cambio profilo e' a tutti gli effetti un nuovo accesso con un altro contatto:
									// registra il lastLogin sul contactId scelto. Escluso il contesto Customer
									// Service, coerentemente con ProfileManagementService.setProfile().
									const cs_externalId = sessionStorage.getItem('cs_externalId')
									if (cs_externalId == null && !!profileSelected?.contactId) {
										this.profileManagementService.updateLastLogin(profileSelected.contactId)
									}
								})
						)
					} else {
						this.profileManagementService.removeProfileFromStore()
						this.profileManagementService.setOnlyProfileAvailable(profiles)
						this.profileManagementService.checkIfRegisteredAndStoreProfileSelected(profiles[0])
					}
				})
		)
	}

	setItemsToManageCredentialDialog(): void {
		const token = this.getDecodedAccessToken(sessionStorage.getItem('id_token'))
		this.subs.add(
			this.dialog.onOpenDialogResponsive(this.isMobile, ManageCredentialsComponent, token.email).subscribe((_) => _)
		)
	}

	checkIfThirdPart() {
		const cs_externalId = sessionStorage.getItem('cs_externalId')
		return cs_externalId
	}

	getThirdPartLabel() {
		const cs_externalId = sessionStorage.getItem('cs_externalId')
		return cs_externalId ? 'Customer Service Operation' : ''
	}

	@HostListener('window:resize', ['$event'])
	onResize(event): void {
		this.isMobileWidth(event.target.innerWidth)
	}

	private isMobileWidth(width): void {
		this.isMobile = width <= 600
		this.updateIconMenu()
	}

	updateIconMenu(): void {
		this.iconMenuUser = this.isMobile ? 'fa-user' : 'fa-chevron-down'
	}

	setIconAttributeForRendering(item): IconModel {
		const iconInput = {
			isMatIcon: item.isMatIcon,
			iconName: item.iconName,
		} as IconModel
		return iconInput
	}
}
